import Header from "../../components/standartComponents/header";
import css from "../../components/lesson/lesson.module.css";
import LessonBlock from "../../components/lesson/lessonBlock";
import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getVideoLessonById } from "../../lib/videoLessonApi";
import Policies from "../../components/standartComponents/policies";
import Loader from "../../components/standartComponents/loader";

const TrialLesson = ({ authUser }) => {
  const id  = "774";
  const navigate = useNavigate();
  const [lesson, setLesson] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchLesson = async () => {
      try {
        const fetchedLesson = await getVideoLessonById(id);
        console.log("fetchedLesson", fetchedLesson);

        setLesson(fetchedLesson);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchLesson();
  }, [id]);

  useEffect(() => {
    if (!loading && (error || !lesson)) {
      navigate("/404");
    }
  }, [loading, error, lesson, navigate]);

  if (loading) {
    return <Loader />
  }

  return (
    <div className={css.wrapAllM}>
      <Header authUser={authUser} />
      {lesson && <LessonBlock lesson={lesson} authUser={authUser} />}{" "}
      <Policies />
    </div>
  );
};

export default TrialLesson;
